var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTelefonoAzul(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4324 10.9109L12.17 10.6526C11.904 10.6214 11.6344 10.6508 11.3814 10.7388C11.1284 10.8267 10.8986 10.9708 10.7093 11.1603L9.07046 12.7992C6.54215 11.513 4.48704 9.45785 3.20084 6.92954L4.84861 5.28177C5.2316 4.89878 5.41864 4.36437 5.3563 3.82105L5.098 1.57652C5.04769 1.14194 4.83922 0.741074 4.51234 0.450327C4.18545 0.159581 3.76301 -0.000712612 3.32553 2.38166e-06H1.78464C0.778169 2.38166e-06 -0.0590761 0.837247 0.00327192 1.84372C0.475336 9.45018 6.55872 15.5247 14.1563 15.9967C15.1628 16.0591 16 15.2218 16 14.2154V12.6745C16.0089 11.7749 15.332 11.0178 14.4324 10.9109Z",
    fill: "#080A44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTelefonoAzul);
export default __webpack_public_path__ + "static/media/ic_telefono_azul.fb42dfaee58e22cab1838de48a77f691.svg";
export { ForwardRef as ReactComponent };